import { xlCol, xlColq } from '../../../common/constants'

export const HeaderColumn = [
  {
    headerName: 'Branch',
    exportHead: 'Branch',
    field: 'Branch',
    xlCol,
  },
  {
    headerName: 'User',
    exportHead: 'User',
    field: 'User',
    xlCol,
  },
  {
    headerName: 'Transaction Type',
    exportHead: 'Transaction Type',
    field: 'TransactionType',
    xlCol,
  },
  {
    headerName: 'Payment Type',
    exportHead: 'Payment Type',
    field: 'PaymentType',
    xlCol,
  },
  {
    headerName: 'Payment Mode',
    exportHead: 'Payment Mode',
    field: 'PaymentMode',
    xlCol,
  },
]

export const getcolumnDefs = (UseFormattedLRinReports, loginCountryId, isTableOne = true) => {
  return [
    {
      headerName: 'Serial Number',
      exportHead: 'S/N',
      field: 'SN',
      xlCol,
    },
    {
      headerName: 'LR Number',
      exportHead: 'LR No',
      field: 'LRNO',
      xlCol,
    },
    UseFormattedLRinReports === 3 && {
      headerName: 'Formatted LR Number',
      exportHead: 'Formatted LRNO',
      field: 'FormattedLRNO',
      xlCol,
    },
    {
      headerName: 'Booking Date',
      exportHead: 'Booking Date',
      field: 'TransactionDate',
      xlCol,
    },
    {
      headerName: 'Source',
      exportHead: 'Source',
      field: 'FromCity',
      xlCol,
    },
    {
      headerName: 'Destination',
      exportHead: 'Destination',
      field: 'ToCity',
      xlCol,
    },
    {
      headerName: 'Payment Type',
      exportHead: 'Pymt.Type',
      field: 'TYPE',
      xlCol,
    },
    {
      headerName: 'Consignment Type',
      exportHead: 'Consign. Type',
      field: 'ConsignmentType',
      xlCol,
    },
		{
      headerName: 'User Name',
      exportHead: 'User Name',
      field: 'UserName',
      xlCol,
    },
    {
      headerName: 'Units',
      exportHead: 'Units',
      field: 'Quantity',
      xlCol: xlColq,
    },
    {
      headerName: 'Freight',
      exportHead: 'Freight',
      field: 'LRAmount',
      xlCol: xlColq,
    },
    {
      headerName: 'Other Charges ',
      exportHead: 'Other Charges ',
      field: 'OtherCharges',
      xlCol: xlColq,
    },
    // loginCountryId !== 2 && {
    //   headerName: 'Booking GST',
    //   exportHead: 'Booking GST',
    //   field: 'GST',
    //   xlCol: xlColq,
    // },
    {
      headerName: 'Total Amount',
      exportHead: 'Total Amount',
      field: 'Amount',
      xlCol: xlColq,
    },
    isTableOne && {
      headerName: 'Delivery Expense',
      exportHead: 'Delivery Expense',
      field: 'DeliveryExpense',
      xlCol: xlColq,
    },
    isTableOne && {
      headerName: 'Net Amount',
      exportHead: 'Net Amount',
      field: 'TotalAmount',
      xlCol: xlColq,
    },
  ].filter(Boolean)
}
export const getSubheading = (total = 14) => {
  return [
    { headerName: 'SN', colspan: total - 10 },
    { headerName: 'FromCity', colspan: 3 },
    { headerName: 'ConsignmentType', colspan: 3 },
    { headerName: 'LRAmount', colspan: 4, textAlign: 'right' },
  ]
}
export const getTotalRow = (UseFormattedLRinReports) => {
  let total = 15;
  if (UseFormattedLRinReports !== 3) {
    total -= 1;
  }
  const fixedCols = 6;
  const snColspan = total - fixedCols;
  return [
    { headerName: 'SN', colspan: snColspan },
    { headerName: 'Quantity', colspan: 1 },
    { headerName: 'LRAmount', colspan: 1 },
    { headerName: 'OtherCharges', colspan: 1 },
    { headerName: 'Amount', colspan: 1 },
    { headerName: 'DeliveryExpense', colspan: 1 },
    { headerName: 'TotalAmount', colspan: 1 },
  ].filter(Boolean);
};

export const tableHeadObject = (val,TranType) => ({
  SN: 'S/N',
  LRNO: `LR NO.`,
  TransactionDate: `${val} Date`,
  FromCity: 'Source',
  ToCity: 'Destination',
  isHeading: true,
  TYPE: 'Payment Type',
  ConsignmentType: 'Consignment Type',
  UserName: 'User Name',
  Quantity: 'Units',
  LRAmount: 'Freight',
  OtherCharges: 'Other Charges',
  // GST: `${val} GST`,
  Amount: 'Total Amount',
  DeliveryExpense : val === "Booking" ? 'Booking Expense' : 'Delivery Expense',
  TotalAmount: 'Net Amount'
})

const baseStyle = {
  minCellHeight: 36,
  fontSize: 16,
  cellPadding: 6,
  valign: "middle",
  fontStyle: "normal",
  font: 'Roboto',
  textColor: [0, 0, 0],
  cellWidth: 'auto'
};

export const getColumnStyle = (addcol = false) => {
  let colWidths = [60,60,60, 79, 100, 100, 100, 120, 90, 120, 70, 70, 70, 70, 130];
  if (addcol) {
    const extraColWidth = 80;
    const shrinkPerCol = Math.floor(extraColWidth / colWidths.length);
    colWidths = colWidths.map(w => w - shrinkPerCol);
    colWidths.splice(2, 0, extraColWidth);
  }
  const colstyles = colWidths.map((width, index) => ({
    ...baseStyle,
    cellWidth: width,
    halign: index > (addcol ? 7 : 6) ? 'right' : 'left'
  }));
  return colstyles;
};

